import React from 'react'
import { Image, ListGroup, Modal } from 'react-bootstrap'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { EMPTY_ARRAY } from '../constants/globalConstants'
import car_check_in from '../assets/img/car_check_in.png'
import moment from 'moment'
import { getCardIcon } from '../utils/helper'
require('./CommonListModal.scss')

function CommonListModal(props) {
    const { isCommonModalOpen, setCommonModal, listData, register, handleCurrentSelection, isThisVehicleModal, currentSelCard, currentSelVehicle } = props

    return (
        <div>
            <Modal show={isCommonModalOpen} onHide={() => setCommonModal()} centered className='commonModalDialogbox' animation={false}>
                <Modal.Body className='scrollable-Modal'>
                    {(!isThisVehicleModal) ? <p className='text-primary  fw-semibold text-center'>Select Card</p> : null}
                    {(isThisVehicleModal) ? <ListGroup as="ol" variant="flush">
                        {listData?.map((item, index) =>
                            <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start" key={index} onClick={() => handleCurrentSelection(item)} {...register('vehicle_id')}>
                                {currentSelVehicle?.license_plate_number ==  item?.license_plate_number ? <i className='fa fa-check p-0 ' style={{ marginTop: '1rem' }}></i> : <i className='fa fa-check p-0 ' style={{ marginTop: '1rem', visibility: 'hidden' }}></i>}
                                <Image src={car_check_in} style={{ height: '3rem' }} />
                                <div className="ms-2 me-auto"><div className="fw-semibold text-primary" style={{ marginTop: '0.7rem' }}>{item?.license_plate_number}</div></div>
                                <span style={{ fontSize: '10px', marginTop: '1rem' }}>{`${item?.make ? item?.make : ''} ${item?.model ? item?.model : ''}`} </span>
                                {(item?.is_default !== '0') ? <span className="colored-circle mt-1" /> : null}
                            </ListGroup.Item>
                        )}
                    </ListGroup> :
                        <ListGroup as="ol">
                            {listData?.map((item, index) =>
                                <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start" key={index} onClick={() => handleCurrentSelection(item)} {...register('card_id' , {require : true})}>
                                    {currentSelCard?.payment_profile_id ==  item?.payment_profile_id ? <i className='fa fa-check p-0 ' style={{ marginTop: '0.9rem' }}></i> : <i className='fa fa-check p-0 ' style={{ marginTop: '0.9rem', visibility: 'hidden' }}></i>}
                                    <Image src={getCardIcon(item?.card_type)} style={{ height: '1.1rem', marginTop: '0.7rem' }} />
                                    <div className="ms-2 me-auto p-2 fw-semibold lh-80" style={{ fontSize: '14px' }}><span className='lh-1'>Card ending in {item?.card_last_four}</span><div><small className='text-secondary'>Expires {moment(item?.expiry, 'MM/YY').format('MM/YY')}</small></div></div>
                                </ListGroup.Item>
                            )}
                        </ListGroup>}
                </Modal.Body>
                <span className='text-danger text-center mb-2' onClick={() => setCommonModal()}>Close</span>

            </Modal>
        </div>
    )
}

CommonListModal.propTypes = {
    dispatch: PropTypes.func,
    isCommonModalOpen: PropTypes.bool,
    setCommonModal: PropTypes.func,
    listData: PropTypes.array,
    register: PropTypes.func,
    handleCurrentSelection: PropTypes.func,
    isThisVehicleModal: PropTypes.bool.isRequired,
    currentSelVehicle: PropTypes.object,
    currentSelCard: PropTypes.object,
}

CommonListModal.defaulProps = {
    dispatch: noop,
    isCommonModalOpen: false,
    setCommonModal: noop,
    listData: EMPTY_ARRAY,
    register: noop,
    handleCurrentSelection: noop,
    isThisVehicleModal: false,
    currentSelVehicle: EMPTY_ARRAY,
    currentSelCard: EMPTY_ARRAY,
}

function mapStateToProps() {
    return {}
}

export default connect(mapStateToProps)(CommonListModal)